import { render } from "./LanguageSelector.vue?vue&type=template&id=cc2d70e0"
import script from "./LanguageSelector.vue?vue&type=script&lang=js"
export * from "./LanguageSelector.vue?vue&type=script&lang=js"

import "./LanguageSelector.vue?vue&type=style&index=0&id=cc2d70e0&lang=css"
script.render = render

export default script